import {
    cleanItem,
    itemEditor,
    ui
} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {YardSignLogic} from "./yard-sign-logic";

export const yardSignModules = ({item, templateOptions}) => [
    {
        name: "yardSign1",
        load: ({}, next) => YardSignLogic({
            item,
            templateOptions,
            next,
        }),
        expo: [cleanItem],
        requires: [],
    },
    {
        load: ({method, yardSign1}, next) => yardSign1.next({
            method,
            next,
        }),
        expo: [ui("yardSign"), itemEditor],
        requires: ["method", "yardSign1"],
    },
];
